import { render, staticRenderFns } from "./returnpurchaseDetails.vue?vue&type=template&id=17424c14&"
import script from "./returnpurchaseDetails.vue?vue&type=script&lang=js&"
export * from "./returnpurchaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./returnpurchaseDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports